import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { Spinner } from 'src/app/core/services/spinner.service';
import { ToastrService } from 'ngx-toastr';
import { TicketRequest } from 'src/app/shared/model/ticket-access-request.model';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from 'src/app/shared/components/dialog/confirmation-dialog.component';
import { MESSAGE_TOAST } from 'src/app/shared/enums/message-toast-enum';
import { Location } from '@angular/common';
import { RenTT } from 'src/app/shared/model/renTT.model';
import { SubscriptionLike } from 'rxjs';
import { RenTTService } from 'src/app/shared/service/ren-tt.service';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-renTT-form',
  templateUrl: './renTT-form.component.html',
  styleUrls: ['./renTT-form.component.scss']
})
export class RenTTFormComponent implements OnInit, OnDestroy {
  RenTT: RenTT = new RenTT();
  RenTTForm: FormGroup;
  request: TicketRequest[] = [];
  isSpin: boolean;
  checkSubmit: boolean;
  roles = ['Storage or Port Mobile User', 'Storage or Port Desktop User'];
  subscription: SubscriptionLike;

  constructor(
    private spinner: Spinner,
    private location: Location,
    private fb: FormBuilder,
    private toastService: ToastrService,
    private dialog: MatDialog,
    private service: RenTTService
  ) { }

  ngOnInit(): void {
    this.RenTTForm = this.fb.group({
      userName: [this.RenTT.userName || '', [Validators.required]],
      firstName: [this.RenTT.firstName || '', [Validators.required]],
      lastName: [this.RenTT.lastName || '', [Validators.required]],
      companyName: [this.RenTT.companyName || '', [Validators.required]],
      email: [this.RenTT.email || '', [Validators.required]],
      access: [this.RenTT.access || '', [Validators.required]],
      role: [{value: this.RenTT.role || '', disabled: true }, [Validators.required]],
      site: [this.RenTT.site || '', [Validators.required]],
      disabled: true
    });

    this.RenTTForm.get('access')?.valueChanges.subscribe((accessValue) => {
      if(accessValue){
        this.RenTTForm.get('role')?.enable();
      } else {
        this.RenTTForm.get('role')?.disable();
      }
    });
    this.getListTicket();
  }

  getListTicket(event?) {
    if (event) {
      event.srcElement.classList.remove('rotate');
      setTimeout(() => {
        event.srcElement.classList.add('rotate');
      }, 0);
    }
    this.subscription = this.service.getRequestRenTTAccessList().subscribe((res) => {
      this.request = res.data;
    }, (err) => {});
  }

  ngOnDestroy() {
    // unsubscribe
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  initFormRenTT() {
    return this.RenTTForm = this.fb.group({
      userName: [this.RenTT.userName || '', [Validators.required]],
      firstName: [this.RenTT.firstName || '', [Validators.required]],
      lastName: [this.RenTT.lastName || '', [Validators.required]],
      companyName: [this.RenTT.companyName || '', [Validators.required]],
      email: [this.RenTT.email || '', [Validators.required]],
      access: [this.RenTT.access || '', [Validators.required]],
      role: [{value: this.RenTT.role || '', disabled: !this.RenTTForm.controls.access.value},[Validators.required]],
      site: [this.RenTT.site || '', [Validators.required]],
      disabled: true
    });
  }

  /**
   * Marks all controls in a form group as touched
   * @param formGroup - The form group to touch
   */
  private markFormGroupTouched(formGroup: FormGroup): void {
    (Object as any).values(formGroup.controls).forEach(control => {
      control.markAsTouched();
      if (control.controls) {
        this.markFormGroupTouched(control);
      }
    });
  }

  submitRenTTForm(): void {
    if (this.checkSubmit) {
      this.setErrorForm(this.RenTTForm);
    }
    if (!this.RenTTForm.valid) {
      this.markFormGroupTouched(this.RenTTForm);
      return;
    } else {
      this.openDialog();
    }
  }

  goToApplication() {
    window.open('https://trackntrace.gerenewableenergy.com/webtrack/');
  }

  getInitFormByID(id) {
    this.spinner.show();
    this.service.getRequestRenTTAccess(id).subscribe((res) => {
      this.spinner.hide();
      this.RenTT = new RenTT(res.data);
      this.initFormRenTT();
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        message: MESSAGE_TOAST.CONFIRM_REQUEST_ACCESS,
        buttonText: {
          ok: 'Yes',
          cancel: 'No'
        }
      }
    });
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        const body = new RenTT(this.RenTTForm.getRawValue(), false).convertToReqBody();
        this.spinner.show();
        this.service.requestRenTTAccess(body).subscribe((res) => {
          this.spinner.hide();
          this.toastService.success(MESSAGE_TOAST.REQUEST_ACCESS_TICKET_SUCCESS);
          // this.RenTTForm.reset();
          // this.getListTicket();
          setTimeout(() => {
            location.reload();
          }, 1000);
          // this.resetForm(this.RenTTForm);
        });
      }
    });
  }

  resetForm(formGroup: FormGroup) {
    let control: AbstractControl = null;
    formGroup.reset();
    formGroup.markAsUntouched();
    Object.keys(formGroup.controls).forEach((name) => {
      control = formGroup.controls[name];
      control.setErrors(null);
    });
    formGroup.setErrors({ invalid: true });
    this.checkSubmit = true;
  }

  setErrorForm(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((name) => {
      if (!formGroup.controls[name].value) {
        formGroup.controls[name].setErrors({ nodata: true });
      }
    });
    return formGroup;
  }

}
